import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import AssignmentAction from "store/assignment-resource/actions"
import { getProductList } from "store/actions"
import StaffAction from "store/staff-resource/actions"
import ScrollBar from "react-perfect-scrollbar"
import { toast } from "react-toastify"
import Skeleton from "react-loading-skeleton"
import DateInput from "components/Common/DateInput"
import moment from "moment"

export default function ArrangementBeSpoke() {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  const [filter, setFilter] = useState({
    weekId: "",
    weekName: "",
    customerName: "",
    scheduledDeliveryDateFrom: "",
    scheduledDeliveryDateTo: "",
    basting: "",
    type: "",
    productId: "",
    productName: "",
    bastingPicId: "",
    bastingPicName: "",
    finisherId: "",
    finisherName: "",
    staffId: "",
    staffName: "",
    scheduledDeliveryDateOrder: "ASC",
  })

  React.useEffect(() => {
    dispatch(AssignmentAction.getWeekList({}, callbackGetWeekList))
    dispatch(getProductList())
    dispatch(StaffAction.getList())
    dispatch(AssignmentAction.getStaffTrouserList())
    dispatch(AssignmentAction.getStaffJacketList())
  }, [])

  const callbackGetWeekList = data => {
    const filtered = data.find(i => i.currentWeek)
    setFilter({
      ...filter,
      weekId: filtered.id,
      weekName: `${filtered.startDate} - ${filtered.endDate}`,
    })
    dispatch(AssignmentAction.getOrderList({ ...filter, weekId: filtered.id }))
  }

  const callbackPut = data => {
    dispatch(
      AssignmentAction.putDataLocal({
        ...data,
        weekId: filter.weekId,
      })
    )

    dispatch(AssignmentAction.getStaffTrouserList())
    dispatch(AssignmentAction.getStaffJacketList())
  }

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const checkingColor = data => {
    if (!data.assignedAlready && data.bastingPicId) {
      return "bg-success"
    } else if (data.assignedAlready) {
      return "bg-light-primary"
    } else {
      return "bg-light-warning"
    }
    // if (!data.assignedAlready && data.bastingPicId) {
    //   return "bg-success"
    // } else if (data.assignedAlready) {
    //   return "bg-light-primary"
    // } else {
    //   return "bg-light-warning"
    // }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"手配"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col xl={3} md="6">
                <Label>作業期間</Label>
                <Select
                  isLoading={store.assignment.weekList.loading}
                  value={{
                    value: filter.weekId,
                    label: filter.weekName,
                  }}
                  options={store.assignment.weekList.data.map(i => ({
                    value: i.id,
                    label: `${i.startDate} - ${i.endDate}`,
                  }))}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        weekId: e.value,
                        weekName: e.label,
                      })
                      dispatch(
                        AssignmentAction.getOrderList({
                          ...filter,
                          weekId: e.value,
                        })
                      )
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <TextInputWithLabel
                  label="顧客名"
                  placeholder={""}
                  value={filter.customerName}
                  type="text"
                  name="customerName"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <Label>受注種別</Label>
                <Select
                  options={[
                    {
                      value: "Bespoke",
                      label: "Bespoke",
                    },
                    {
                      value: "MTM",
                      label: "MTM",
                    },
                    {
                      value: "RTW",
                      label: "RTW",
                    },
                  ]}
                  onChange={e => {
                    if (e) {
                      setFilter({ ...filter, type: e.value })
                    } else {
                      setFilter({ ...filter, type: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={6}>
                <Label>納品予定日</Label>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <DateInput
                    placeholder="年/月/日"
                    className="form-control"
                    value={filter.scheduledDeliveryDateFrom}
                    onChange={date => {
                      setFilter({
                        ...filter,
                        scheduledDeliveryDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateFrom: "" })
                    }
                  />
                  <div>~</div>
                  <DateInput
                    placeholder="年/月/日"
                    className="form-control"
                    value={filter.scheduledDeliveryDateTo}
                    minDate={filter.scheduledDeliveryDateFrom}
                    onChange={date =>
                      setFilter({ ...filter, scheduledDeliveryDateTo: date[0] })
                    }
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateTo: "" })
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <Label>商品</Label>
                <Select
                  options={store.products.list.map(i => ({
                    value: i.id,
                    label: i.productName,
                  }))}
                  value={{
                    value: filter.productId,
                    label: filter.productName,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        productId: e.value,
                        productName: e.label,
                      })
                    } else {
                      setFilter({
                        ...filter,
                        productId: "",
                        productName: "",
                      })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={3}>
                <Label>仮縫い</Label>
                <Select
                  options={[
                    {
                      label: "あり",
                      value: true,
                    },
                    {
                      label: "なし",
                      value: false,
                    },
                  ]}
                  onChange={e => {
                    if (e) {
                      setFilter({ ...filter, basting: e.value })
                    } else {
                      setFilter({ ...filter, basting: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={3}>
                <Label>仮縫い担当者</Label>
                <Select
                  isLoading={store.staff.list.loading}
                  options={store.staff.list.data.map(i => ({
                    value: i.id,
                    label: i.name,
                  }))}
                  value={{
                    value: filter.bastingPicId,
                    label: filter.bastingPicName,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        bastingPicId: e.value,
                        bastingPicName: e.label,
                      })
                    } else {
                      setFilter({
                        ...filter,
                        bastingPicId: "",
                        bastingPicName: "",
                      })
                    }
                  }}
                  isClearable
                />
              </Col>
              <Col md={3}>
                <Label>仕上げ担当者</Label>
                <Select
                  isLoading={store.staff.list.loading}
                  options={store.staff.list.data.map(i => ({
                    value: i.id,
                    label: i.name,
                  }))}
                  value={{
                    value: filter.finisherId,
                    label: filter.finisherName,
                  }}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        finisherId: e.value,
                        finisherName: e.label,
                      })
                    } else {
                      setFilter({ ...filter, finisherId: "", finisherName: "" })
                    }
                  }}
                  isClearable
                />
              </Col>
            </Row>
            <Row className="mt-3 justify-content-end">
              <Col md={6} className="text-end">
                <div>
                  <span>
                    <Button
                      className={
                        filter.scheduledDeliveryDateOrder == "DESC"
                          ? "button-active"
                          : "button"
                      }
                      disabled={filter.scheduledDeliveryDateOrder == "ASC"}
                      onClick={() => {
                        setFilter({
                          ...filter,
                          scheduledDeliveryDateOrder: "ASC",
                        })
                        dispatch(
                          AssignmentAction.getOrderList({
                            ...filter,
                            scheduledDeliveryDateOrder: "ASC",
                          })
                        )
                      }}
                    >
                      昇順
                    </Button>
                    <Button
                      className={`${
                        filter.scheduledDeliveryDateOrder == "ASC"
                          ? "button-active"
                          : "button"
                      } ms-2`}
                      // className="ms-2"
                      disabled={filter.scheduledDeliveryDateOrder == "DESC"}
                      onClick={() => {
                        setFilter({
                          ...filter,
                          scheduledDeliveryDateOrder: "DESC",
                        })
                        dispatch(
                          AssignmentAction.getOrderList({
                            ...filter,
                            scheduledDeliveryDateOrder: "DESC",
                          })
                        )
                      }}
                    >
                      降順
                    </Button>
                  </span>

                  <SButton
                    className="mx-2 button"
                    onClick={() => {
                      const filtered = { ...filter }
                      filtered.scheduledDeliveryDateFrom =
                        filter.scheduledDeliveryDateFrom &&
                        moment(filter.scheduledDeliveryDateFrom).format(
                          "YYYY-MM-DD"
                        )
                      filtered.scheduledDeliveryDateTo =
                        filter.scheduledDeliveryDateTo &&
                        moment(filter.scheduledDeliveryDateTo).format(
                          "YYYY-MM-DD"
                        )

                      dispatch(AssignmentAction.getOrderList({ ...filtered }))
                    }}
                  >
                    検索
                  </SButton>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row>
          <Col lg="8">
            <ScrollBar style={{ height: 500 }}>
              <Row>
                {store.assignment.order.loading ? (
                  // store.assignment.putOrder.loading ||
                  // store.assignment.deleteOrder.loading ||
                  // store.assignment.patchData.loading
                  <Skeleton count={5} />
                ) : (
                  store.assignment.order.data.map((i, k) => {
                    return (
                      <Col lg="4" key={k}>
                        <Card className={`${checkingColor(i)}`}>
                          <CardBody>
                            <Row>
                              <Col>
                                <div>{i.orderNumber}</div>
                                <div>{i.customerName}</div>
                                <div>{i.productName}</div>
                                <div>{!i.orderForm ? "お直し" : i.type}</div>
                                <div>
                                  {i.basting ? "あり" : "なし"}{" "}
                                  {i.fittingDate ? `(${i.fittingDate})` : ""}
                                </div>
                                <div>{i.scheduledDeliveryDate || "-"}</div>
                                <div>
                                  {i.priceTaxIncluded &&
                                    i.priceTaxIncluded.toLocaleString("ja-JP")}
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              {i.basting && (
                                <>
                                  <Col lg="12">
                                    <Label>仮縫い担当者</Label>
                                    <Card>
                                      <CardBody
                                        style={{
                                          padding: "12px",
                                        }}
                                      >
                                        <div
                                          className={`${
                                            i.bastingPicName
                                              ? "bg-info text-white py-1 px-2 rounded d-flex align-items-start justify-content-between"
                                              : "d-flex flex-wrap gap-2 p-2"
                                          }`}
                                          onDrop={e => {
                                            e.preventDefault()

                                            let data =
                                              e.dataTransfer.getData("text")

                                            const parsed = JSON.parse(data)
                                            if (i?.finisher?.length >= 3) {
                                              toast.error(
                                                "仕上げ担当は３人までです。"
                                              )
                                              return
                                            }
                                            dispatch(
                                              AssignmentAction.putOrder(
                                                {
                                                  weekId: filter.weekId,
                                                  sequence: i?.finisher?.length
                                                    ? i?.finisher?.length + 1
                                                    : 1,
                                                  bastingPicId: parsed.id,
                                                  // finisherId: i.fi,
                                                  id: i.id,
                                                },
                                                callbackPut
                                              )
                                            )
                                          }}
                                          onDragOver={e => {
                                            e.preventDefault()
                                          }}
                                        >
                                          <div>{i.bastingPicName}</div>
                                          {i.bastingPicName && (
                                            <Badge
                                              role="button"
                                              color="danger"
                                              className="ms-2"
                                              style={{
                                                cursor: i.finishedBasting
                                                  ? "none"
                                                  : "pointer",
                                              }}
                                              onClick={() => {
                                                i.finishedBasting
                                                  ? null
                                                  : dispatch(
                                                      AssignmentAction.deleteOrder(
                                                        {
                                                          bastingPicId:
                                                            i.bastingPicId,
                                                          weekId: filter.weekId,
                                                          id: i.id,
                                                        },
                                                        callbackPut
                                                      )
                                                    )
                                              }}
                                            >
                                              x
                                            </Badge>
                                          )}
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                  <Col lg="12" className="mt-2">
                                    <Input
                                      type="checkbox"
                                      checked={i.finishedBasting}
                                      onClick={() => {
                                        dispatch(
                                          AssignmentAction.patchData(
                                            {
                                              id: i.id,
                                              status: !i.finishedBasting,
                                            },
                                            callbackPut
                                          )
                                        )
                                      }}
                                      onChange={() => {}}
                                      disabled={
                                        i.finisher?.length > 0 ? true : false
                                      }
                                    />{" "}
                                    仮縫い完了
                                  </Col>
                                </>
                              )}

                              <Col lg="12" className="mt-2">
                                <Label>仕上げ担当者</Label>
                                <br />
                                <Card>
                                  <CardBody
                                    style={{
                                      padding:
                                        i?.finisher?.length > 0
                                          ? "0px"
                                          : "12px",
                                    }}
                                    className={`${
                                      !i.finishedBasting &&
                                      i.basting &&
                                      "bg-light"
                                    } `}
                                  >
                                    <div
                                      className="d-flex flex-wrap gap-2 p-2"
                                      onDrop={e => {
                                        e.preventDefault()
                                        if (!i.finishedBasting && i.basting) {
                                          return
                                        }
                                        let data =
                                          e.dataTransfer.getData("text")

                                        const parsed = JSON.parse(data)

                                        if (i?.finisher?.length >= 3) {
                                          toast.error(
                                            "仕上げ担当は３人までです。"
                                          )
                                          return
                                        }

                                        if (i.orderForm) {
                                          if (i.orderForm != parsed.title) {
                                            return toast.error(
                                              `職人種類をもう一度ご確認ください`
                                            )
                                          }
                                        }
                                        dispatch(
                                          AssignmentAction.putOrder(
                                            {
                                              weekId: filter.weekId,
                                              sequence: i?.finisher?.length
                                                ? i?.finisher?.length + 1
                                                : 1,
                                              bastingPicId: null,
                                              finisherId: parsed.id,
                                              id: i.id,
                                            },
                                            callbackPut
                                          )
                                        )
                                      }}
                                      onDragOver={e => {
                                        e.preventDefault()
                                      }}
                                    >
                                      {i?.finisher &&
                                        i?.finisher.map((j, l) => (
                                          <div
                                            draggable={j.deletable}
                                            onDragEnd={e => {
                                              dispatch(
                                                AssignmentAction.deleteOrder(
                                                  {
                                                    weekId: filter.weekId,
                                                    sequence: j.sequence,
                                                    finisherId: j.finisherId,
                                                    id: i.id,
                                                  },
                                                  callbackPut
                                                )
                                              )
                                            }}
                                            className={`bg-info text-white py-1 px-2 rounded d-flex justify-content-between align-items-start`}
                                            key={l}
                                          >
                                            <div>{j.finisherName}</div>
                                            {j.deletable && (
                                              <Badge
                                                role="button"
                                                color="danger"
                                                className="ms-2"
                                                onClick={() => {
                                                  dispatch(
                                                    AssignmentAction.deleteOrder(
                                                      {
                                                        weekId: filter.weekId,
                                                        sequence: j.sequence,
                                                        finisherId:
                                                          j.finisherId,
                                                        id: i.id,
                                                      },
                                                      callbackPut
                                                    )
                                                  )
                                                }}
                                              >
                                                x
                                              </Badge>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    )
                  })
                )}
              </Row>
            </ScrollBar>
          </Col>
          <Col lg="4" style={{ height: 250 }}>
            <Card>
              <ScrollBar style={{ height: 237 }}>
                <CardHeader>トラウザーズ担当者</CardHeader>
                <CardBody>
                  <div className="d-flex flex-wrap gap-2">
                    {store.assignment.staffListTrouser.loading ? (
                      <Skeleton count={5} />
                    ) : (
                      store.assignment.staffListTrouser.data.map((i, k) => (
                        <span
                          id={i.id}
                          title={i.form}
                          role="button"
                          className={`p-2 ${
                            filter.staffId == i.id
                              ? "bg-primary text-white"
                              : "bg-light"
                          }`}
                          key={k}
                          draggable
                          onDragStart={e => {
                            e.dataTransfer.setData(
                              "text",
                              JSON.stringify({
                                id: e.target.id,
                                title: e.target.title,
                              })
                            )
                          }}
                          onClick={() => {
                            if (filter.staffId == i.id) {
                              setFilter({
                                ...filter,
                                staffId: "",
                                staffName: "",
                              })
                              dispatch(
                                AssignmentAction.getOrderList({
                                  ...filter,
                                  staffId: "",
                                })
                              )
                            } else {
                              setFilter({
                                ...filter,
                                staffId: i.id,
                                staffName: i.name,
                              })
                              dispatch(
                                AssignmentAction.getOrderList({
                                  ...filter,
                                  staffId: i.id,
                                })
                              )
                            }
                          }}
                        >
                          <span className="me-3">{i.name}</span>
                          <Badge>{i.totalAssignment}</Badge>
                        </span>
                      ))
                    )}
                  </div>
                </CardBody>
              </ScrollBar>
            </Card>
            <Card>
              <ScrollBar style={{ height: 237 }}>
                <CardHeader>ジャケット担当者</CardHeader>

                <CardBody>
                  <div className="d-flex flex-wrap gap-2">
                    {store.assignment.staffListJacket.loading ? (
                      <Skeleton count={5} />
                    ) : (
                      store.assignment.staffListJacket.data.map((i, k) => (
                        <span
                          id={i.id}
                          title={i.form}
                          role="button"
                          className={`p-2 ${
                            filter.staffId == i.id
                              ? "bg-primary text-white"
                              : "bg-light"
                          }`}
                          key={k}
                          draggable
                          onDragStart={e => {
                            e.dataTransfer.setData(
                              "text",
                              JSON.stringify({
                                id: e.target.id,
                                title: e.target.title,
                              })
                            )
                          }}
                          onClick={() => {
                            if (filter.staffId == i.id) {
                              setFilter({
                                ...filter,
                                staffId: "",
                                staffName: "",
                              })
                              dispatch(
                                AssignmentAction.getOrderList({
                                  ...filter,
                                  staffId: "",
                                })
                              )
                            } else {
                              setFilter({
                                ...filter,
                                staffId: i.id,
                                staffName: i.name,
                              })
                              dispatch(
                                AssignmentAction.getOrderList({
                                  ...filter,
                                  staffId: i.id,
                                })
                              )
                            }
                          }}
                        >
                          <span className="me-3">{i.name}</span>
                          <Badge>{i.totalAssignment}</Badge>
                        </span>
                      ))
                    )}
                  </div>
                </CardBody>
              </ScrollBar>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
